import React from 'react';

const SessionItem = ({
  session,
  isActive,
  onSessionClick,
  onSessionDelete,
  onSessionRename,
  canDelete
}) => {
  const formatSessionPreview = () => {
    const messageCount = session.messages.length;
    const lastMessage = session.messages[messageCount - 1];
    const lastMessagePreview = lastMessage 
      ? (lastMessage.role === 'user' ? lastMessage.content : 'AI: ' + lastMessage.content)
      : '无消息';
    
    return lastMessagePreview.length > 30 
      ? lastMessagePreview.substring(0, 30) + '...' 
      : lastMessagePreview;
  };

  return (
    <div className={`session-item ${isActive ? 'active' : ''}`}>
      <div 
        className="session-name" 
        onClick={() => onSessionClick(session.id)}
        onDoubleClick={() => {
          const newName = prompt('输入新的会话名称:', session.name);
          if (newName) {
            onSessionRename(session.id, newName);
          }
        }}
      >
        <div className="session-info">
          <div className="session-title">{session.name}</div>
          <div className="session-preview">{formatSessionPreview()}</div>
        </div>
      </div>
      {canDelete && (
        <button 
          className="delete-btn"
          onClick={(e) => {
            e.stopPropagation();
            onSessionDelete(session.id, session.name);
          }}
        >
          ×
        </button>
      )}
    </div>
  );
};

export default SessionItem; 